import { Suspense } from 'react';

import { ResearchPerfEvalCriteriaGathering } from '@/module/ResearchPerfEval/components/ResearchPerfEvalCriteriaGathering';
import { ResearchPerfEvalCriteria } from '@/module/ResearchPerfEval/model/ResearchPerfEvalTypes';

import { PendingSpinner } from '@/core/components';

import { Id } from '@feature/utils';

interface AuthorResearchPerfEvalWizardProps {
  evaluationId: Id;
  authorId: Id;
  template: ResearchPerfEvalCriteria;
  isResearchPerfEvalClosed: boolean;
}

export function AuthorResearchPerfEvalWizard(props: AuthorResearchPerfEvalWizardProps) {
  const { evaluationId, template, authorId, isResearchPerfEvalClosed } = props;
  return (
    <Suspense fallback={<PendingSpinner h="300px" />}>
      <ResearchPerfEvalCriteriaGathering
        criteria={template}
        evaluationId={evaluationId}
        authorId={authorId}
        isResearchPerfEvalClosed={isResearchPerfEvalClosed}
      />
    </Suspense>
  );
}
